import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols);
} return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); });
} return target; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { store } from "@root/store";
import { getDownloadURL } from "firebase/storage";
import { collection, doc, getDoc, getDocs, updateDoc, writeBatch } from "firebase/firestore";
import { push } from "connected-react-router/esm/index.js";
import { tabDockInit } from "@comp/project-editor/actions";
import { selectDefaultTargetName, selectTarget } from "@comp/target-controls/selectors";
import { selectLoggedInUid } from "@comp/login/selectors";
import { updateProjectLastModified } from "@comp/project-last-modified/actions";
import { selectTabDockIndex } from "@comp/project-editor/selectors";
import { openSimpleModal } from "../modal/actions";
import { filter as _filter, find, isEmpty } from "lodash";
import { append, assoc, concat, filter, forEach, path, pathOr, reduce, values } from "ramda";
import { ACTIVATE_PROJECT, ADD_PROJECT_DOCUMENTS, DOCUMENT_INITIALIZE, DOCUMENT_RESET, DOCUMENT_RENAME_LOCALLY, DOCUMENT_REMOVE_LOCALLY, DOCUMENT_SAVE, DOCUMENT_UPDATE_VALUE, DOCUMENT_UPDATE_MODIFIED_LOCALLY, CLOSE_PROJECT, SET_PROJECT_PUBLIC, STORE_PROJECT_LOCALLY, UNSET_PROJECT } from "./types";
import { addDocumentToEMFS, convertProjectSnapToProject, fileDocumentDataToDocumentType } from "./utils";
import { database, getFirebaseTimestamp, projects, storageReference } from "@config/firestore";
import JSZip from "jszip";
import { saveAs } from "file-saver";
export var downloadProjectOnce = function downloadProjectOnce(projectUid) {
    return /*#__PURE__*/ function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(dispatch) {
            var projReference, projSnap, project;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1)
                    switch (_context.prev = _context.next) {
                        case 0:
                            projReference = doc(projects, projectUid);
                            _context.prev = 1;
                            _context.next = 4;
                            return getDoc(projReference);
                        case 4:
                            projSnap = _context.sent;
                            _context.next = 10;
                            break;
                        case 7:
                            _context.prev = 7;
                            _context.t0 = _context["catch"](1);
                            return _context.abrupt("return");
                        case 10:
                            if (!(projSnap && projSnap.exists)) {
                                _context.next = 16;
                                break;
                            }
                            _context.next = 13;
                            return convertProjectSnapToProject(projSnap);
                        case 13:
                            project = _context.sent;
                            _context.next = 16;
                            return dispatch(storeProjectLocally([project]));
                        case 16:
                        case "end":
                            return _context.stop();
                    }
            }, _callee, null, [[1, 7]]);
        }));
        return function (_x) {
            return _ref.apply(this, arguments);
        };
    }();
};
export var downloadAllProjectDocumentsOnce = function downloadAllProjectDocumentsOnce(projectUid) {
    return /*#__PURE__*/ function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee3(dispatch) {
            var filesReference, allDocuments, allDocumentsMap;
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1)
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return getDocs(collection(doc(projects, projectUid), "files"));
                        case 2:
                            filesReference = _context3.sent;
                            _context3.next = 5;
                            return Promise.all(filesReference.docs.map(/*#__PURE__*/ function () {
                                var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2(d) {
                                    var data;
                                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                                        while (1)
                                            switch (_context2.prev = _context2.next) {
                                                case 0:
                                                    _context2.next = 2;
                                                    return d.data();
                                                case 2:
                                                    data = _context2.sent;
                                                    return _context2.abrupt("return", fileDocumentDataToDocumentType(assoc("documentUid", d.id, data)));
                                                case 4:
                                                case "end":
                                                    return _context2.stop();
                                            }
                                    }, _callee2);
                                }));
                                return function (_x3) {
                                    return _ref3.apply(this, arguments);
                                };
                            }()));
                        case 5:
                            allDocuments = _context3.sent;
                            allDocumentsMap = reduce(function (accumulator, document_) {
                                return assoc(document_.documentUid, document_, accumulator);
                            }, {}, allDocuments);
                            _context3.next = 9;
                            return dispatch({
                                type: ADD_PROJECT_DOCUMENTS,
                                projectUid: projectUid,
                                documents: allDocumentsMap
                            });
                        case 9:
                        case "end":
                            return _context3.stop();
                    }
            }, _callee3);
        }));
        return function (_x2) {
            return _ref2.apply(this, arguments);
        };
    }();
};
export var newEmptyDocumentAction = function newEmptyDocumentAction(projectUid, documentUid, filename) {
    return {
        type: DOCUMENT_INITIALIZE,
        filename: filename,
        documentUid: documentUid,
        projectUid: projectUid
    };
};
export var closeProject = function closeProject() {
    return {
        type: CLOSE_PROJECT
    };
};
export var activateProject = function activateProject(projectUid) {
    return /*#__PURE__*/ function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee4(dispatch) {
            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1)
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            dispatch({
                                type: ACTIVATE_PROJECT,
                                projectUid: projectUid
                            });
                        case 1:
                        case "end":
                            return _context4.stop();
                    }
            }, _callee4);
        }));
        return function (_x4) {
            return _ref4.apply(this, arguments);
        };
    }();
};
export var storeProjectLocally = function storeProjectLocally(projects) {
    return {
        type: STORE_PROJECT_LOCALLY,
        projects: projects
    };
};
export var unsetProject = function unsetProject(projectUid) {
    return {
        type: UNSET_PROJECT,
        projectUid: projectUid
    };
};
export var addProjectDocuments = function addProjectDocuments(projectUid, documents) {
    return /*#__PURE__*/ function () {
        var _ref5 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee5(dispatch, getState) {
            var store, tabIndex, maybeDefaultTargetName, maybeDefaultTarget;
            return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1)
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            store = getState();
                            tabIndex = selectTabDockIndex(store);
                            _context5.next = 4;
                            return dispatch({
                                type: ADD_PROJECT_DOCUMENTS,
                                projectUid: projectUid,
                                documents: documents
                            });
                        case 4:
                            if (tabIndex < 0) {
                                maybeDefaultTargetName = selectDefaultTargetName(projectUid, store);
                                maybeDefaultTarget = selectTarget(projectUid, maybeDefaultTargetName, store);
                                dispatch(tabDockInit(projectUid, values(documents), maybeDefaultTarget));
                            }
                        case 5:
                        case "end":
                            return _context5.stop();
                    }
            }, _callee5);
        }));
        return function (_x5, _x6) {
            return _ref5.apply(this, arguments);
        };
    }();
};
export var resetDocumentValue = function resetDocumentValue(projectUid, documentUid) {
    return {
        type: DOCUMENT_RESET,
        projectUid: projectUid,
        documentUid: documentUid
    };
};
export var saveFile = function saveFile() {
    return /*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee6() {
        var state, dock, activeTab, documentUid, activeProjectUid, project, document_;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1)
                switch (_context6.prev = _context6.next) {
                    case 0:
                        state = store.getState();
                        dock = state.ProjectEditorReducer.tabDock;
                        activeTab = dock.openDocuments[dock.tabIndex];
                        documentUid = activeTab.uid;
                        activeProjectUid = pathOr("", ["ProjectsReducer", "activeProjectUid"], state);
                        project = pathOr({}, ["ProjectsReducer", "projects", activeProjectUid], state);
                        document_ = project && find(project.documents, function (d) {
                            return d.documentUid === documentUid;
                        });
                        if (project && document_) {
                            try {
                                updateDoc(doc(collection(doc(projects, project.projectUid), "files"), document_.documentUid), {
                                    value: document_.currentValue,
                                    lastModified: getFirebaseTimestamp()
                                });
                                updateProjectLastModified(project.projectUid);
                            }
                            catch (_unused2) { }
                        }
                    case 8:
                    case "end":
                        return _context6.stop();
                }
        }, _callee6);
    }));
};
export var saveAllFiles = function saveAllFiles() {
    return /*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee7() {
        var state, activeProjectUid, project, documents, batch;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1)
                switch (_context7.prev = _context7.next) {
                    case 0:
                        state = store.getState();
                        activeProjectUid = pathOr("", ["ProjectsReducer", "activeProjectUid"], state);
                        project = pathOr({}, ["ProjectsReducer", "projects", activeProjectUid], state);
                        documents = project && _filter(Object.values(project.documents), function (d) {
                            return d.isModifiedLocally;
                        });
                        if (project && documents && !isEmpty(documents)) {
                            batch = writeBatch(database);
                            documents.forEach(function (document_) {
                                batch.update(doc(collection(doc(projects, project.projectUid), "files"), document_.documentUid), {
                                    value: document_.currentValue,
                                    lastModified: getFirebaseTimestamp()
                                });
                            });
                            batch.commit();
                            updateProjectLastModified(project.projectUid);
                        }
                    case 5:
                    case "end":
                        return _context7.stop();
                }
        }, _callee7);
    }));
};
export var saveAllAndClose = function saveAllAndClose(dispatch, goTo) {
    return saveAllFiles()().then(function () {
        return dispatch(push(goTo));
    }, console.error);
};
// for unauthorized or offline playing
export var saveFileOffline = function saveFileOffline(csound, activeProjectUid, document, newValue) {
    var pathPrefix = document.path || [];
    var absolutePath = concat(["/".concat(activeProjectUid)], append(document.filename, pathPrefix)).join("/");
    addDocumentToEMFS(activeProjectUid, csound, assoc("savedValue", newValue, document), absolutePath);
};
// for unauthorized or offline playing
export var saveAllOffline = function saveAllOffline(csound) {
    var state = store.getState();
    var activeProjectUid = pathOr("", ["ProjectsReducer", "activeProjectUid"], state);
    var project = path(["ProjectsReducer", "projects", activeProjectUid], state);
    if (project) {
        var documents = Object.values(project.documents);
        forEach(function (document) {
            var pathPrefix = document.path || [];
            var absolutePath = concat(["/".concat(activeProjectUid)], append(document.filename, pathPrefix)).join("/");
            addDocumentToEMFS(activeProjectUid, csound, assoc("savedValue", document.currentValue, document), absolutePath);
        }, documents);
    }
};
export var deleteFile = function deleteFile(projectUid, documentUid) {
    return /*#__PURE__*/ function () {
        var _ref8 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee8(dispatch, getState) {
            var state, project, document_, allNestedFiles, allFilesToDelete;
            return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                while (1)
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            state = getState();
                            project = pathOr({}, ["ProjectsReducer", "projects", projectUid], state);
                            if (project) {
                                document_ = project.documents[documentUid];
                                if (document_ && document_.type === "folder") {
                                    allNestedFiles = filter(function (d) {
                                        return (d.path || []).includes(documentUid);
                                    }, project.documents);
                                    allFilesToDelete = append(document_, values(allNestedFiles));
                                    dispatch(openSimpleModal("delete-document-prompt", {
                                        filename: document_.filename,
                                        isFolder: true,
                                        folderContents: allFilesToDelete,
                                        documentUid: documentUid,
                                        projectUid: projectUid
                                    }));
                                }
                                else if (document_) {
                                    dispatch(openSimpleModal("delete-document-prompt", {
                                        filename: document_.filename,
                                        isFolder: false,
                                        folderContents: [],
                                        documentUid: documentUid,
                                        projectUid: projectUid
                                    }));
                                }
                                else {
                                    console.error("No document found with id", projectUid);
                                }
                            }
                            else {
                                console.error("No project found with id", projectUid);
                            }
                        case 3:
                        case "end":
                            return _context8.stop();
                    }
            }, _callee8);
        }));
        return function (_x7, _x8) {
            return _ref8.apply(this, arguments);
        };
    }();
};
export var saveUpdatedDocument = function saveUpdatedDocument(projectUid, document) {
    return {
        type: DOCUMENT_SAVE,
        document: document,
        projectUid: projectUid
    };
};
export var updateDocumentValue = function updateDocumentValue(value, projectUid, documentUid) {
    return /*#__PURE__*/ function () {
        var _ref9 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee9(dispatch) {
            return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                while (1)
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            dispatch({
                                type: DOCUMENT_UPDATE_VALUE,
                                val: value,
                                projectUid: projectUid,
                                documentUid: documentUid
                            });
                        case 1:
                        case "end":
                            return _context9.stop();
                    }
            }, _callee9);
        }));
        return function (_x9) {
            return _ref9.apply(this, arguments);
        };
    }();
};
export var updateDocumentModifiedLocally = function updateDocumentModifiedLocally(isModified, projectUid, documentUid) {
    return /*#__PURE__*/ function () {
        var _ref10 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee10(dispatch) {
            return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                while (1)
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            dispatch({
                                type: DOCUMENT_UPDATE_MODIFIED_LOCALLY,
                                isModified: isModified,
                                documentUid: documentUid,
                                projectUid: projectUid
                            });
                        case 1:
                        case "end":
                            return _context10.stop();
                    }
            }, _callee10);
        }));
        return function (_x10) {
            return _ref10.apply(this, arguments);
        };
    }();
};
export var newFolder = function newFolder(projectUid) {
    return openSimpleModal("new-folder-prompt", {
        projectUid: projectUid
    });
};
export var newDocument = function newDocument(projectUid, initFilename) {
    return openSimpleModal("new-document-prompt", {
        isRenameAction: false,
        initFilename: initFilename,
        projectUid: projectUid
    });
};
export var addDocument = function addDocument(projectUid) {
    return openSimpleModal("add-document-prompt", {
        projectUid: projectUid
    });
};
export var renameDocumentLocally = function renameDocumentLocally(documentUid, newFilename) {
    return {
        type: DOCUMENT_RENAME_LOCALLY,
        newFilename: newFilename,
        documentUid: documentUid
    };
};
export var removeDocumentLocally = function removeDocumentLocally(projectUid, documentUid) {
    return {
        type: DOCUMENT_REMOVE_LOCALLY,
        projectUid: projectUid,
        documentUid: documentUid
    };
};
export var renameDocument = function renameDocument(projectUid, documentUid) {
    var state = store.getState();
    var project = pathOr({}, ["ProjectsReducer", "projects", projectUid], state);
    if (!project) {
        console.error("Project", projectUid, "was not found!");
        return;
    }
    var currentFilename = pathOr("", ["documents", documentUid, "filename"], project);
    return openSimpleModal("new-document-prompt", {
        isRenameAction: true,
        initFilename: currentFilename,
        projectUid: projectUid,
        renameDocumentUid: documentUid
    });
};
var createExportPath = function createExportPath(folders, document_) {
    if (!folders || pathOr([], ["path"], document_).length === 0) {
        return document_.filename;
    }
    var paths = document_.path.map(function (d) {
        return folders[d].filename;
    });
    return "".concat(paths.join("/"), "/").concat(document_.filename);
};
export var exportProject = function exportProject() {
    return /*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee11() {
        var state, activeProjectUid, project, zip, folder, documents, folders, _i, _documents, document_, _path, url, response, blob, exportPath, _exportPath;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
            while (1)
                switch (_context11.prev = _context11.next) {
                    case 0:
                        state = store.getState();
                        activeProjectUid = pathOr("", ["ProjectsReducer", "activeProjectUid"], state);
                        project = pathOr({}, ["ProjectsReducer", "projects", activeProjectUid], state);
                        if (isEmpty(project)) {
                            _context11.next = 38;
                            break;
                        }
                        zip = new JSZip();
                        folder = zip.folder("project");
                        documents = Object.values(project.documents);
                        folders = documents.filter(function (d) {
                            return d.type === "folder";
                        })
                            /* eslint-disable unicorn/prefer-object-from-entries */ .reduce(function (m, f) {
                            return _objectSpread(_objectSpread({}, m), {}, _defineProperty({}, f.documentUid, f));
                        }, {});
                        if (folders) {
                            _context11.next = 11;
                            break;
                        }
                        console.error("No folders found.");
                        return _context11.abrupt("return");
                    case 11:
                        _i = 0, _documents = documents;
                    case 12:
                        if (!(_i < _documents.length)) {
                            _context11.next = 37;
                            break;
                        }
                        document_ = _documents[_i];
                        if (!(document_.type === "bin")) {
                            _context11.next = 33;
                            break;
                        }
                        _path = "".concat(project.userUid, "/").concat(project.projectUid, "/").concat(document_.documentUid);
                        _context11.t0 = getDownloadURL;
                        _context11.next = 19;
                        return storageReference(_path);
                    case 19:
                        _context11.t1 = _context11.sent;
                        _context11.next = 22;
                        return (0, _context11.t0)(_context11.t1);
                    case 22:
                        url = _context11.sent;
                        _context11.next = 25;
                        return fetch(url);
                    case 25:
                        response = _context11.sent;
                        _context11.next = 28;
                        return response.arrayBuffer();
                    case 28:
                        blob = _context11.sent;
                        exportPath = createExportPath(folders, document_);
                        if (exportPath && folder && folder.file) {
                            folder.file(exportPath, blob, {
                                binary: true
                            });
                        }
                        else {
                            console.error("whoops, no export path was created");
                        }
                        _context11.next = 34;
                        break;
                    case 33:
                        if (document_.type === "txt") {
                            _exportPath = createExportPath(folders, document_);
                            folder.file(_exportPath, document_.savedValue);
                        }
                    case 34:
                        _i++;
                        _context11.next = 12;
                        break;
                    case 37:
                        zip.generateAsync({
                            type: "blob"
                        }).then(function (content) {
                            saveAs(content, "project.zip");
                        });
                    case 38:
                    case "end":
                        return _context11.stop();
                }
        }, _callee11);
    }));
};
export var markProjectPublic = function markProjectPublic(projectUid, isPublic) {
    return /*#__PURE__*/ function () {
        var _ref12 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee12(dispatch, getState) {
            var state, loggedInUserUid;
            return _regeneratorRuntime.wrap(function _callee12$(_context12) {
                while (1)
                    switch (_context12.prev = _context12.next) {
                        case 0:
                            state = getState();
                            loggedInUserUid = selectLoggedInUid(state);
                            if (!(!loggedInUserUid || !projectUid)) {
                                _context12.next = 4;
                                break;
                            }
                            return _context12.abrupt("return");
                        case 4:
                            _context12.next = 6;
                            return updateDoc(doc(projects, projectUid), {
                                public: isPublic
                            });
                        case 6:
                            dispatch({
                                type: SET_PROJECT_PUBLIC,
                                projectUid: projectUid,
                                isPublic: isPublic
                            });
                            updateProjectLastModified(projectUid);
                        case 8:
                        case "end":
                            return _context12.stop();
                    }
            }, _callee12);
        }));
        return function (_x11, _x12) {
            return _ref12.apply(this, arguments);
        };
    }();
};
